

import React from "react";
import heroImage from "../../assets/images/Herosection/herobanner.jpg";

const brandColors = {
  cream: "#F3EEE4",
  creamDark: "#EAE2D3",

  crimson: "#A10F1A",
  crimsonDark: "#7A0C14",

  gold: "#C79A3B",
  goldLight: "#D9B56B",

  black: "#1A1A1A",
  brown: "#5A3A1A",
};

const HeroSection = () => {
  return (
    <section
      className="relative text-white pt-16 overflow-hidden"
      style={{ background: "#0d0505" }}
    >
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src={heroImage}
          alt="Law Expertise"
          className="w-full h-full object-cover"
          style={{ filter: "brightness(0.3) saturate(1.2)" }}
        />

        <div
          className="absolute inset-0"
          style={{
            background:
              "linear-gradient(135deg, rgba(139,26,26,0.65) 0%, rgba(13,5,5,0.85) 55%)",
          }}
        />
      </div>

      {/* Gold top border */}
      <div
        className="absolute top-0 left-0 right-0 z-10"
        style={{
          height: "3px",
          background: `linear-gradient(90deg, transparent, ${brandColors.gold}, ${brandColors.crimson}, ${brandColors.gold}, transparent)`,
        }}
      />

      

      {/* Hero Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 py-12 lg:text-left">
        {/* Eyebrow */}
        <div className="flex items-center gap-3 mb-5">
          <span
            style={{
              width: "32px",
              height: "1px",
              background: brandColors.gold,
            }}
          />

          <span
            style={{
              fontFamily: "'Cinzel', serif",
              fontSize: "11px",
              letterSpacing: "0.25em",
              color: brandColors.gold,
              textTransform: "uppercase",
            }}
          >
            R & P Law Partners
          </span>

          <span
            style={{
              width: "32px",
              height: "1px",
              background: `linear-gradient(90deg, ${brandColors.gold}, transparent)`,
            }}
          />
        </div>

        {/* Heading */}
        <h1
          style={{
            fontFamily: "'Cinzel', serif",
            fontSize: "clamp(32px, 5vw, 56px)",
            fontWeight: 700,
            lineHeight: 1.15,
            letterSpacing: "0.04em",
            textTransform: "uppercase",
            color: brandColors.cream,
            marginBottom: "8px",
          }}
        >
          Protecting Your <br />
          <span style={{ color: brandColors.gold }}>
            Rights & Interests
          </span>
        </h1>

        {/* Divider */}
        <div className="flex items-center gap-3 my-5">
          <div
            style={{
              flex: 1,
              height: "0.5px",
              background: `linear-gradient(90deg, ${brandColors.gold}, transparent)`,
            }}
          />

          <div
            style={{
              width: "6px",
              height: "6px",
              border: `1px solid ${brandColors.gold}`,
              transform: "rotate(45deg)",
            }}
          />

          <div
            style={{
              flex: 1,
              height: "0.5px",
              background: `linear-gradient(90deg, transparent, ${brandColors.gold})`,
            }}
          />
        </div>

        {/* Subtext */}
        <p
          style={{
            fontFamily: "'Cormorant Garamond', Georgia, serif",
            fontSize: "17px",
            fontStyle: "italic",
            color: "rgba(245,240,232,0.80)",
            lineHeight: 1.7,
            marginBottom: "28px",
            maxWidth: "560px",
          }}
        >
          R & P  Law Partners provides expert legal guidance with 
          years of experience. Trusted by clients for transparency,
          dedication  and results.
        </p>

        {/* Stats */}
      

        {/* CTA Buttons */}
        <div className="flex flex-col md:flex-row gap-4">
          <a
            href="/contact-us"
            style={{
              fontFamily: "'Cinzel', serif",
              fontSize: "11px",
              fontWeight: 600,
              letterSpacing: "0.18em",
              textTransform: "uppercase",
              padding: "13px 28px",
              background: brandColors.gold,
              color: brandColors.crimsonDark,
              display: "inline-block",
              transition: "background 0.3s",
              textDecoration: "none",
            }}
            onMouseEnter={(e) =>
              (e.currentTarget.style.background =
                brandColors.goldLight)
            }
            onMouseLeave={(e) =>
              (e.currentTarget.style.background =
                brandColors.gold)
            }
          >
            Schedule Consultation
          </a>

          {/* <a
            href="/practice-areas"
            style={{
              fontFamily: "'Cinzel', serif",
              fontSize: "11px",
              fontWeight: 400,
              letterSpacing: "0.18em",
              textTransform: "uppercase",
              padding: "12px 28px",
              background: "transparent",
              color: brandColors.cream,
              border: "0.5px solid rgba(201,168,76,0.45)",
              display: "inline-block",
              transition: "border-color 0.3s, color 0.3s",
              textDecoration: "none",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.borderColor =
                brandColors.gold;
              e.currentTarget.style.color = brandColors.gold;
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.borderColor =
                "rgba(201,168,76,0.45)";
              e.currentTarget.style.color = brandColors.cream;
            }}
          >
            Practice Areas
          </a> */}
        </div>
      </div>

      {/* Watermark */}
      <div
        className="absolute bottom-0 right-0 pointer-events-none select-none z-0"
        style={{
          fontFamily: "'Cinzel', serif",
          fontSize: "clamp(80px, 18vw, 140px)",
          fontWeight: 700,
          color: "rgba(139,26,26,0.07)",
          lineHeight: 1,
          textTransform: "uppercase",
        }}
      >
        Justice
      </div>
    </section>
  );
};

export default HeroSection;